import { INTERACTION_TYPES } from 'craft/types';

import { interactions } from './constants';

export const getDefaultAction = (interactionType?: INTERACTION_TYPES, eventName?: string) => {
  const interaction = interactions
    .find((iterator) => iterator.id === interactionType)
    ?.defaultAction();

  if (!interaction) {
    return null;
  }

  return { ...((interaction as object) || {}), eventName };
};
